import React from 'react';

export interface PaymentCardProps {
  active: boolean;
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export function PaymentCard({ active, title, subtitle, icon, onClick }: PaymentCardProps): React.ReactElement {
  return (
    <button type="button" onClick={onClick} className={"rounded-md cursor-pointer text-left font-sans text-ink " + (active ? "border border-brand bg-brand-bg" : "border border-hairline bg-white")} style={{ padding: "16px 14px" }}>
      <div className="mb-1.5 flex items-center gap-2">
        {icon}
        <span className="text-body font-medium">{title}</span>
        <span className={"ml-auto inline-flex h-4 w-4 items-center justify-center rounded-full " + (active ? "border border-ink" : "border border-hairline")}>
          {active && <span className="block h-1.5 w-1.5 rounded-full bg-ink" />}
        </span>
      </div>
      <div className="text-tiny text-sub">{subtitle}</div>
    </button>
  );
}
